import { FeatureRole, Resource, ResourceType } from "types";
import { hasFeature } from "../models/Seller";
import { useSeller } from "./useAccount";
import { useAutoFetchCollection } from "./useAutoFetchCollection";

export const useHasEquipment = (): boolean => {
    const seller = useSeller();
    const canPurchaseEquipment =
        hasFeature(seller, FeatureRole.SELLER_INVENTORY) &&
        seller.preferences.inventory.allowEquipmentAsPurchasableUnit;

    const { data: resources } = useAutoFetchCollection<Resource>(
        "resources",
        { seller: seller.id },
        { enabled: canPurchaseEquipment && !!seller.id },
    );

    return canPurchaseEquipment && (resources ?? []).some((resource) => resource.type === ResourceType.EQUIPMENT);
};
